import React, { FC, ReactElement, useState } from 'react';
import { Button, IconProps, SxProps, Theme } from '@mui/material';

interface IconHoverButtonComponentProps {
    startIcon?: ReactElement<IconProps>,
    endIcon?: ReactElement<IconProps>,
    sx?: SxProps<Theme>,
    onClick?: ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void) | undefined,
    children: React.ReactNode;
}

const IconHoverButtonComponent: FC<IconHoverButtonComponentProps> = (props) => {
    const { startIcon, endIcon, sx, onClick, children } = props;
    const [showIcon, setShowIcon] = useState<boolean>(false);
    return (
        <Button
            data-testid="IconHoverButtonComponent"
            variant="text"
            fullWidth
            onMouseEnter={() => setShowIcon(true)}
            onMouseLeave={() => setShowIcon(false)}
            startIcon={showIcon && startIcon}
            endIcon={showIcon && endIcon}
            sx={sx}
            onClick={onClick}
        >
            {children}
        </Button>
    );
};

export default IconHoverButtonComponent;

IconHoverButtonComponent.defaultProps = {
    startIcon: undefined,
    endIcon: undefined,
    sx: {},
    onClick: undefined,
};
